import * as React from "react"
import Layout from "../components/layout"

import { Container } from 'react-bootstrap';

const ImpressumPage = () => {

    return (

        <Layout pageTitle="Impressum DER OPTIKER zielinski">

            <br></br>
            <br></br>
            <br></br>
            <br></br>

            <Container>

                <h5>Allgemeine Infos</h5>

                <ul>
                    <li><b>der optiker zielinski</b></li>
                    <li> <a href="https://goo.gl/maps/3VYCLvb8WnSK7pKT6" target="_blank" rel="noopener noreferrer">Simmeringer Platz 1, 1110 Wien</a></li>
                    <li><a href="tel:+43 1 749 2203">Tel.: +43 1 749 2203</a></li>
                    <li>d.optiker[at]gmail.com</li>
                    <li> <a href="http://www.deroptiker.at" target="_blank" rel="noopener noreferrer">www.deroptiker.at</a></li>

                </ul>

                <br></br>
                <br></br>

                <h5>Offenlegung nach Mediengesetz:</h5>

                <ul>
                    <li>Medieninhabung: Michael Zielinski</li>
                    <li>Firmensitz: 1110 Wien, Simmeringer Platz 1</li>
                    <li>Unternehmensgegenstand: Optiker</li>
                    <li>Geschäftsführung- und Inhabung: Michael Zielinski</li>
                    <li>Behörde gem. ECG: Magistratisches Bezirksamt für den 11. Bezirk</li>
                    <li>Anwendbare gewerberechtliche Vorschriften: Gewerbeordnung: www.ris.bka.gv.at</li>
                    <li>Kammerzugehörigkeit: Wirtschaftskammer Wien</li>

                </ul>

                <br></br>
                <br></br>


                <h5>Allgemeine Infos</h5>

                <p>Auf diesen Seiten befinden sich Links zu externen Seiten im Internet. 
                    Für alle diese Links gilt: Der Seiteninhaber erklärt hiermit ausdrücklich, 
                    dass er keinerlei Einfluss auf die Gestaltung und die Inhalte der gelinkten Seiten hat. 
                    Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten gelinkter Seiten auf dieser 
                    Homepage und macht sich diese Inhalte nicht zu Eigen. Diese Erklärung gilt für alle auf dieser 
                    Homepage angezeigten Links (in welcher Form auch immer). Für Hinweise ist der Seiteninhaber dankbar, 
                    so dass er umgehend Links mit fragwürdigen Inhalten entfernen kann.</p>

                <p>Die Grafiken und der Code dieser Homepage unterliegen ausschliesslich dem Copyright des Seiteninhabers 
                    bzw. dessen Partnern (außer Slideshows, Sound, ... und/ oder wenn nicht anders angegeben). Inhalte dürfen 
                    ohne Genehmigung des Seiteninhabers weder kopiert noch in irgend einer Weise weiterverwendet werden.</p>


                <p>Des weiteren haftet der Seiteninhaber nicht für Schäden, die durch die Nutzung von Daten und/ oder 
                    Inhalten dieser Homepage Usern entstehen können.</p>


                <h5>Haftung für Links</h5>

                <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                    Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
                    Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten 
                    wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum 
                    Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist 
                    jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
                    Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>


                <h5>Datenschutzerklärung hinsichtlich der Nutzung der Dienste Google Analytics</h5>

                <p>Unserer Seite macht Gebrauch von Google Analytics, einem Analysedienst von Google Inc. (Google). 
                    Dieser wiederum nutzt so genannte „Cookies“, Textdateien, die auf Ihrem Computer gespeichert werden, und 
                    räumt uns auf diese Weise die Möglichkeit ein, die Benutzung unserer Seite durch Sie und andere Nutzer zu 
                    analysieren. Durch die Cookies erfolgt eine Sammlung der Informationen über den Gebrauch der Website, 
                    insbesondere der IP- Adresse, und es findet eine Übermittlung an den Server von Google in den USA statt, 
                    auf dem diese gespeichert werden.</p>


                <p>Die Verwendung der Informationen erfolgt zum Zwecke der Analyse Ihres Gebrauchs der Website, um Berichte 
                    und Daten über das Verhalten im Rahmen der Benutzung der Website zu sammeln und um noch anderweitige 
                    Leistung von unserer Seite zu tätigen. Möglicherweise findet eine Übermittlung der Daten an Dritte durch 
                    Google statt, sofern Google dazu gesetzlich verpflichtet ist oder für den Fall, dass Dritte eine Verarbeitung 
                    dieser Daten vornehmen. Durch Google wird jedoch niemals eine Verbindung Ihrer IP- Adresse mit anderen 
                    Informationen hergestellt und auf diese Weise ein Profil angefertigt. Die Einstellungen für den Browser können 
                    derart geändert werden, dass diese Cookies nicht gespeichert werden. Sollten Sie diese Änderungen tatsächlich 
                    vornehmen, könnte es allerdings dazu kommen, dass Sie nicht alle von der Website bereit gestellten Funktionen 
                    vollständig benutzen können. Die Speicherung und Sammlung der Informationen, die das Cookie bezüglich der Nutzung 
                    der Website bewirkt, und deren Verarbeitung durch Google kann unterbunden werden, indem Sie unter dem 
                    Link 

                    <a href="https://g.page/r/CRIBMnqxKhdmEAg/review" target="_blank" rel="noopener noreferrer"> http://tools.google.com/dlpage/gaoptout?hl=de </a>
                    
                    die für die Verhinderung dieser Erzeugung und Benutzung der 
                    Informationen erforderlichen Plug- Ins herunterladen, die das verhindert.
                </p>



            </Container>


        </Layout>

    )

}

export default ImpressumPage